export default {"src":"/_next/static/media/editor-green.2c00f98c.svg","height":14,"width":15};